import { createRoot } from "react-dom/client";
import Polish from "./Polish.jsx";

createRoot(document.getElementById("root")).render(<Polish />);
